import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import firebase from 'firebase'
import JsonExcel from "vue-json-excel";
import i18n from '@/i18n'

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyBBufcIbfxM6L5M9k_xfjIQoXT3BTXNCqw",
  authDomain: "iap-next.firebaseapp.com",
  projectId: "iap-next",
  storageBucket: "iap-next.appspot.com",
  messagingSenderId: "1007895501355",
  appId: "1:1007895501355:web:b2729a71e60f876a40686e",
  measurementId: "G-ZS6YKXL3E9"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
firebase.analytics()
Vue.component("downloadExcel", JsonExcel);

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
